
interface PlateProps {
    URL: string
    corners: number[][]
    width: number
    height: number
    style?: Object
}


export const PlateImage:React.FC<PlateProps> = ({
    URL,
    corners,
    width,
    height,
    style
}) => {

    const flatCorners = [...corners[0],...corners[1]].join(',')
    const params = `width=${width}&height=${height}&perspective=${flatCorners}`

    return (<>
        <img
            src={`${URL}?${params}`}
            width={width}
            height={height}
            style={style}
            alt="License plate"
        />
    </>)

}

export default PlateImage;